import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FontSizes from '../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const InfoMessageBox = (props) => {
    return (
        <View style={[styles.container, props.style]}>
            <View style={{ marginRight: 10 }}>
                <MaterialCommunityIcons name="information-outline"
                    size={24} color={'#3e7bb1'} />
            </View>
            <Text style={styles.messageText}>
                {props.messageText}
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        padding: 10,
        alignItems: 'center',
        backgroundColor: '#cde9f7',
        borderWidth: 2,
        borderColor: '#3e7bb1',
        flexDirection: 'row',
    },
    messageText: {
        color: '#3e7bb1',
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.5,
        lineHeight: 24,
        flex: 1, 
        flexWrap: 'wrap'
    }
});

export default InfoMessageBox;
